import jwtDecode from 'jwt-decode';

export const storeToken = (data) => {
  localStorage.setItem('authtoken', data);
};
export const storeProfile = (data) => {
  localStorage.setItem('profile', JSON.stringify(data));
};

export const userLogout = () => {
  localStorage.clear();
  window.location.replace('/login');
};
export const getToken = () => {
  // get token from the cookie
  const authString = localStorage.getItem('authtoken');
  switch (authString) {
    case '':
      return false;
    case null:
      return false;
    case 'undefined':
      return false;
    default:
      return authString;
  }
};

export const getProfile = () => {
  // Never throws: a malformed `profile` used to take down whichever module
  // parsed it, and several modules parsed it at import time.
  try {
    const authString = localStorage.getItem('profile');
    if (!authString || authString === 'undefined') return false;
    return JSON.parse(authString);
  } catch (error) {
    console.error('Stored profile is not valid JSON; treating as signed out.', error);
    return false;
  }
};

export const removeToken = () => {
  localStorage.removeItem('authtoken');
};

class AuthService {
  constructor() {
    this.authenticated = false;
    this.auth = {};
  }

  logout() {
    this.authenticated = false;
    userLogout();
  }

  isAuthenticated() {
    this.checkValidity();
    return this.authenticated;
  }

  checkValidity() {
    const token = getToken();
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded.exp > Date.now() / 1000) {
        this.authenticated = true;
      } else {
        removeToken();
        this.authenticated = false;

        // return false;
      }
    } else {
      removeToken();
      this.authenticated = false;
    }
  }
}

export default new AuthService();
